<template>
  <div style="width:100%;height:100%;">

    <!-- 上传进度 -->
    <el-progress type="circle" v-if="file.uploading" :percentage="file.percentage" ></el-progress>
    <!-- 图片 -->
    <img
      v-else
      class="el-upload-list__item-thumbnail"
      :src="file.url+'!128'"
      alt=""
    >
    <!-- hover显示 -->
    <span class="el-upload-list__item-actions flex_middle">
      <!-- 这里的小预览图必须等file.previewUrl处理完再显示 -->
      <span v-if="fileUrl" class="el-upload-list__item-preview">
        <el-image
          :src="fileUrl +'!128'"
          style="width: 50px; height: 50px; border-radius: 50%"
          :preview-src-list="
            fileList.map((i) => i.url)
          "
        />
      </span>
      <!-- 删除 -->
      <span
        class="el-upload-list__item-delete"
        @click="
              onRemove(file)
            "
      >
        <i class="el-icon-delete" />
      </span>
    </span>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import bus from '@/utils/bus'

export default {
  props: {
    file: {
      type: Object,
      default: () => null
    },
    fileList: {
      type: Array,
      default: () => []
    }

  },

  computed: {
    fileUrl() {
      return this.file.url
    }
  },
  data(){
    return {
    }
  },
  mounted(){

  },
  methods: {
    ...mapMutations({
      onRemoveFile: 'upload/onRemoveFile'
    }),

    onRemove(file) {
      this.$emit('onRemove', file)
    },
  }

}
</script>

<style>

</style>
